import Cookies from 'js-cookie';

export type Organization = 'doordash' | 'wolt';

export const organization: Organization = Cookies.get('dd') ? 'doordash' : 'wolt';
